import React, { useEffect, useRef, useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import Buttons from "../../../library/custom/button/Button";
import GridTable from "../../../library/custom/gridTable/GridTable";
import {
  API_STATUS,
  ASSET_TYPE_JHA,
  JHA_STATUS_VALUE,
  GRID_DEFAULT_PAGE_SIZE,
  ROW_PER_PAGE_SIZE,
  USER_ID,
} from "../../../constant/constant";
import { TableLoader } from "../../../library/common/Loader";
import NORow from "../../../library/custom/noRow/noRow";
import ReportRowManipulte from "../../incidents/incidentList/ReportRowManipulte";
import { useNavigate } from "react-router-dom";
import FilterListIcon from "@mui/icons-material/FilterList";
import FilterCommonStatusSelect from "../../admin/shared/FilterCommonStatusSelect";
import { getFormatedDate } from "../../../utils/helper";
import {
  CONDUCT_JHA,
  CONDUCT_JHA_REPORT,
} from "../../../constant/routeContant";
import { checkPrivileges } from "../../../utils/rolesHelper";
import downloadIcon from "../../../assets/downloadIcon.svg";
import DialogBox from "../../../library/common/DialogBox";
import { useDebounce } from "../../../utils/useDebounceSearch";

export default function ConductJhaList({
  getConductJhaList,
  conductJhaListData,
  isLoading,
  NavigateAddConductjha,
  deleteConductJha,
  deleteConductJhaData,
  shouldRestoreState,
}) {
  const navigate = useNavigate();
  const [fromDate, setFromDate] = useState(null);
  const [toDate, setToDate] = useState(null);
  const [asetType, setAssetType] = useState();
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const [pageSize, setPageSize] = useState(GRID_DEFAULT_PAGE_SIZE);
  const [page, setPage] = useState(0);
  const [anchorEl, setAnchorEl] = useState(null);
  const [isTableLoading, setisTableLoading] = useState(false);
  const [conductJhaListApiData, setConductJhaListApiData] = useState({
    page: 1,
    pageSize: pageSize,
    search: "",
    endDate: toDate ? getFormatedDate(toDate) : "",
    startDate: fromDate ? getFormatedDate(fromDate) : "",
    userId: 0,
    assetType: 0,
    status: "",
    isSendMail: false,
  });
  const [openModal, setOpenModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState("");
  const deletehandle = () => {
    const data = {
      conductId: selectedRow?.id,
      userId: parseInt(USER_ID()),
    };
    deleteConductJha(data);
    setOpenModal(false);
  };

  const onchangeToDatePicker = (e) => {
    setToDate(e);
  };
  const onchangeFromDatePicker = (e) => {
    setFromDate(e);
  };

  const [filter, setFilter] = useState({
    page: 1,
    pageSize: pageSize,
    search: "",
    endDate: toDate ? getFormatedDate(toDate) : "",
    startDate: fromDate ? getFormatedDate(fromDate) : "",
    userId: 0,
    assetType: asetType ? asetType : 0,
    isSendMail: false,
  });

  const assetTypeOnChanges = (e) => {
    setAssetType(e.target.value);
  };

  const statusOnChanges = (e) => {
    setStatusFilter(e.target.value);
  };

  const handleSearch = (data) => {
    setAnchorEl(null);
    getConductJhaList(data);
  };

  const handleApply = (state) => {
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);

    setConductJhaListApiData({
      ...conductJhaListApiData,
      endDate: toDate ? getFormatedDate(toDate) : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      assetType: asetType ? asetType : 0,
      status: statusFilter !== undefined ? statusFilter : "",
      isSendMail: false,
    });
    setAnchorEl(null);
    const data = {
      ...conductJhaListApiData,
      page: 1,
      pageSize: pageSize,
      search: conductJhaListApiData.search,
      endDate: toDate ? getFormatedDate(toDate) : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      userId: 0,
      assetType: asetType ? asetType : 0,
      status: statusFilter !== undefined ? statusFilter : "",
      isSendMail: false,
    };
    getConductJhaList(data);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    window.close();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const handlePageSizeChange = (newPazeSize) => {
    setPageSize(newPazeSize);
    setConductJhaListApiData({
      ...conductJhaListApiData,
      isSendMail: false,
      page: 1,
      pageSize: newPazeSize,
    });
    getConductJhaList({
      ...conductJhaListApiData,
      isSendMail: false,
      page: 1,
      pageSize: newPazeSize,
    });
  };

  const handlePagignation = (newPage) => {
    setPage(newPage);
    const data = {
      ...conductJhaListApiData,
      page: newPage + 1,
      isSendMail: false,
    };
    setConductJhaListApiData({
      ...conductJhaListApiData,
      page: newPage + 1,
      isSendMail: false,
    });
    getConductJhaList(data);
  };

  const handleautoSearch = (event) => {
    let searchText = "";
    if (event.target.value) {
      searchText = event.target.value;
    }
    setSearch(searchText);
    setPage(0);
  };

  const handleClear = () => {
    setFromDate("");
    setToDate("");
    setAssetType("");
    setStatusFilter("");
    setSearch("");
    setPage(0);
    setPageSize(GRID_DEFAULT_PAGE_SIZE);
    const data = {
      page: 1,
      pageSize: GRID_DEFAULT_PAGE_SIZE,
      search: "",
      endDate: "",
      startDate: "",
      userId: 0,
      assetType: 0,
      status: "",
      isSendMail: false,
    };
    setPage(0);
    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);
    setConductJhaListApiData(data);
    handleSearch(data);
  };

  const handleOnViewclick = (rows) => {
    sessionStorage.setItem("conductJhaListPreserveState", "true");
    navigate(CONDUCT_JHA_REPORT, {
      state: { id: rows.row.id, editMode: true },
    });
  };

  const handleOnEditclick = (rows) => {
    sessionStorage.setItem("conductJhaListPreserveState", "true");
    navigate(CONDUCT_JHA, {
      state: { id: rows.row.id, editMode: true },
    });
  };
  const handleOnDeleteclick = (rows) => {
    setOpenModal(true);
    setSelectedRow(rows);
  };

  const onRowClick = (rows) => {
    if (rows.value) {
      sessionStorage.setItem("conductJhaListPreserveState", "true");
      navigate(CONDUCT_JHA_REPORT, {
        state: { id: rows.row.id, editMode: true },
      });
    }
  };

  const credcloumns = [
    { field: "id", headerName: "ID", flex: 2.8 },
    { field: "templateName", headerName: "Templates Name", flex: 4 },
    { field: "dateOfEntry", headerName: "Date of Entry", flex: 4 },
    { field: "assetName", headerName: "Asset Name", flex: 4 },
    { field: "assetType", headerName: "Asset Type", flex: 3 },
    { field: "conductedBy", headerName: "Conducted by", flex: 3.4 },
    {
      field: "status",
      headerName: "Status",
      flex: 2.3,
      renderCell: (params) => (params.value === 1 ? "Draft" : "Completed"),
    },
    {
      field: "",
      width: 70,
      sortable: false,
      disableClickEventBubbling: true,
      renderCell: (rows) => {
        return (
          <ReportRowManipulte
            rows={rows}
            credentialLists={true}
            viewOnClick={() => handleOnViewclick(rows)}
            edit={checkPrivileges([12, 123, 124])}
            editLabel="Edit Hazard Analysis Report"
            editOnClick={() => handleOnEditclick(rows)}
            download={false}
            view={checkPrivileges([12, 123, 124, 125])}
            viewLabel="View Hazard Analysis Report"
            deleted={checkPrivileges([12, 123])}
            deleteLabel="Delete Hazard Analysis Report"
            deleteOnClick={() => handleOnDeleteclick(rows)}
          />
        );
      },
    },
  ];

  const sendEmail = () => {
    const data = {
      ...conductJhaListApiData,
      page: page + 1,
      isSendMail: true,
    };
    setConductJhaListApiData(data);
    getConductJhaList(data);
  };
  useEffect(() => {
    if (shouldRestoreState && conductJhaListData?.filterObj) {
      const f = conductJhaListData.filterObj;
      setSearch(f.search || "");
      setFromDate(f.startDate || "");
      setToDate(f.endDate || "");
      setAssetType(f.assetType || "");
      setStatusFilter(f.status || "");
      setPage((f.page || 1) - 1);
      setPageSize(f.pageSize || GRID_DEFAULT_PAGE_SIZE);
      setConductJhaListApiData({
        page: f.page || 1,
        pageSize: f.pageSize || GRID_DEFAULT_PAGE_SIZE,
        search: f.search || "",
        endDate: f.endDate || "",
        startDate: f.startDate || "",
        userId: f.userId || 0,
        assetType: f.assetType || 0,
        status: f.status || "",
        isSendMail: false,
      });
    }
  }, [shouldRestoreState]);

  const isFirstRender = useRef(true);

  useEffect(() => {
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }
    setPage(0);
    const data = {
      ...conductJhaListApiData,
      page: 1,
      pageSize: pageSize,
      search: debouncedSearch ? debouncedSearch : "",
      endDate: toDate ? getFormatedDate(toDate) : "",
      startDate: fromDate ? getFormatedDate(fromDate) : "",
      assetType: asetType ? asetType : 0,
      userId: 0,
      isSendMail: false,
    };

    setisTableLoading(true);
    setTimeout(() => {
      setisTableLoading(false);
    }, 1);

    setConductJhaListApiData(data);
    getConductJhaList(data);
  }, [debouncedSearch]);
  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Hazard Analysis Reports</div>
          {openModal && (
            <DialogBox
              open={openModal}
              rows={[]}
              header={"Confirm Deletion"}
              deletehandle={deletehandle}
              handleCloseModal={() => setOpenModal(false)}
              content={
                "Are you sure you want to delete this hazard analysis report?"
              }
              view
            />
          )}
          <div>
            <div className="filter_btn">
              {checkPrivileges([123, 124, 12]) && (
                <Buttons
                  id="btnAddClient"
                  label={"Add Hazard Analysis Report"}
                  varientAddIconBlue={true}
                  onClick={NavigateAddConductjha}
                ></Buttons>
              )}
            </div>
          </div>
        </div>
        <div className="grid_main_body">
          <div className="div-filter-container">
            <div className="filter_of_caselist">
              <div className="searchcaseid">
                <label htmlFor="search">
                  <span>
                    <SearchIcon />
                  </span>
                  <div>
                    <input
                      id="search"
                      placeholder="Search"
                      type="text"
                      value={search}
                      className=""
                      onChange={handleautoSearch}
                      autoComplete="off"
                    />
                  </div>
                </label>
              </div>

              <div className="filter_btn">
                <button
                  aria-describedby={id}
                  variant="contained"
                  type="button"
                  name="btn"
                  onClick={(e) => handleClick(e)}
                >
                  <FilterListIcon id="icn" /> Filters
                </button>
                <FilterCommonStatusSelect
                  id={id}
                  open={open}
                  anchorEl={anchorEl}
                  handleClose={handleClose}
                  handleApply={handleApply}
                  handleClear={handleClear}
                  filter={filter}
                  selectLable={"Asset Type"}
                  categoryType={ASSET_TYPE_JHA}
                  category={asetType}
                  categoryOnChanges={assetTypeOnChanges}
                  filterSelect={true}
                  resetBtn={true}
                  filterDate={true}
                  toDate={toDate}
                  fromDate={fromDate}
                  onchangeToDatePicker={onchangeToDatePicker}
                  onchangeFromDatePicker={onchangeFromDatePicker}
                  minDate={true}
                  statusFilterSelect={true}
                  statusSelectLable={"Status"}
                  statusCategoryType={JHA_STATUS_VALUE}
                  statusCategory={statusFilter}
                  statusCategoryOnChanges={statusOnChanges}
                />
              </div>
            </div>
            <div className="div-download-email-right" onClick={sendEmail}>
              <span>
                <img
                  src={downloadIcon}
                  className="DownLoadLogo"
                  alt="DownLoad Logo"
                />
              </span>
              Download Data
            </div>
          </div>

          <div className="desc_box row_uniq">
            <div className="table_style_ui">
              {isTableLoading ? (
                ""
              ) : (
                <GridTable
                  getRowId={(r) => r?.id}
                  rows={conductJhaListData?.data?.result?.itemList ?? []}
                  rowCount={conductJhaListData?.data?.result?.itemsCount ?? 0}
                  columns={credcloumns}
                  loading={isLoading}
                  checkboxSelection={false}
                  page={page}
                  pagination
                  pageSize={pageSize}
                  onClick={(rows) => onRowClick(rows)}
                  rowsPerPageOptions={ROW_PER_PAGE_SIZE}
                  onPageSizeChange={handlePageSizeChange}
                  onPageChange={handlePagignation}
                  backIconButtonProps={{ disabled: false }}
                  disableSelectionOnClick
                  components={{
                    LoadingOverlay: TableLoader,
                    NoRowsOverlay: NORow,
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
